import { tolgee } from 'services/i18n/tolgee';
// 对齐 Knowledge ErrorCode / KnowledgeTaskReasonCode；两套码表独立，诊断 message 不进 UI。
type Translate = (key: string) => string;
export const knowledgeApiErrorKeys: Readonly<Record<string, string>> = {
  NOT_FOUND: 'knowledgeErrors.notFound',
  SYSTEM_RUNTIME_ERROR: 'knowledgeErrors.failed',
  TEMPLATE_NOT_FOUND: 'knowledgeErrors.notFound',
  KNOWLEDGE_NOT_FOUND: 'knowledgeErrors.notFound',
  ACTIVITY_NOT_FOUND: 'knowledgeErrors.notFound',
  SPU_CLASS_NAME_DUPLICATED: 'knowledgeErrors.duplicate',
  PHYSICAL_PRODUCT_NAME_DUPLICATED: 'knowledgeErrors.duplicate',
  MARK_TAG_GET_TRADE_FAIL: 'knowledgeErrors.failed',
  MARK_TAG_GET_DEPARTMENT_FAIL: 'knowledgeErrors.failed',
  MARK_TAG_GET_REVIEW_FAIL: 'knowledgeErrors.failed',
  READ_EXCEL_FAIL: 'knowledgeErrors.parse',
  NOT_SUPPORT_DEFINITION_CODE: 'knowledgeErrors.invalid',
  GROUP_NAME_DUPLICATED: 'knowledgeErrors.duplicate',
  AI_QUERY_REWRITE_FAIL: 'knowledgeErrors.failed',
  HISTORY_QUESTION_FINALIZE_INVALID_REQUEST: 'knowledgeErrors.invalid',
  HISTORY_QUESTION_FINALIZE_JOB_NOT_FOUND: 'knowledgeErrors.notFound',
  HISTORY_QUESTION_FINALIZE_RETRY_CONFLICT: 'knowledgeErrors.conflict',
  CIH_HISTORY_QUESTION_INVALID_REQUEST: 'knowledgeErrors.invalid',
  CIH_HISTORY_QUESTION_JOB_NOT_FOUND: 'knowledgeErrors.notFound',
  CIH_HISTORY_QUESTION_BATCH_SEALED: 'knowledgeErrors.conflict',
  CIH_HISTORY_QUESTION_BATCH_NOT_READY: 'knowledgeErrors.busy',
  CIH_HISTORY_QUESTION_BATCH_BUSY: 'knowledgeErrors.busy',
  SPU_DETAIL_INVALID_REQUEST: 'knowledgeErrors.invalid',
  SPU_DETAIL_UNAUTHORIZED: 'knowledgeErrors.unauthorized',
  SPU_DETAIL_NOT_FOUND: 'knowledgeErrors.notFound',
  SPU_DETAIL_CONFLICT: 'knowledgeErrors.conflict',
  SPU_DETAIL_MONTHLY_TASK_LIMIT_REACHED: 'knowledgeErrors.quota',
  SPU_DETAIL_DISABLED: 'knowledgeErrors.disabled',
  SPU_DETAIL_INTERNAL_ERROR: 'knowledgeErrors.failed',
  DOCUMENT_KNOWLEDGE_INVALID_REQUEST: 'knowledgeErrors.invalid',
  DOCUMENT_KNOWLEDGE_UNAUTHORIZED: 'knowledgeErrors.unauthorized',
  DOCUMENT_KNOWLEDGE_NOT_FOUND: 'knowledgeErrors.notFound',
  DOCUMENT_KNOWLEDGE_CONFLICT: 'knowledgeErrors.conflict',
  DOCUMENT_KNOWLEDGE_IDEMPOTENCY_CONFLICT: 'knowledgeErrors.idempotency',
  DOCUMENT_KNOWLEDGE_MONTHLY_TASK_LIMIT_REACHED: 'knowledgeErrors.quota',
  DOCUMENT_KNOWLEDGE_INTERNAL_ERROR: 'knowledgeErrors.failed',
  PRODUCT_KNOWLEDGE_INVALID_REQUEST: 'knowledgeErrors.invalid',
  PRODUCT_KNOWLEDGE_SCOPE_CONFLICT: 'knowledgeErrors.conflict',
  KNOWLEDGE_VALUE_INVALID_REQUEST: 'knowledgeErrors.invalid',
  KNOWLEDGE_TIME_SCOPE_CONFLICT: 'knowledgeErrors.conflict',
  SUPPLEMENTAL_KNOWLEDGE_INVALID_REQUEST: 'knowledgeErrors.invalid',
  SUPPLEMENTAL_KNOWLEDGE_NOT_FOUND: 'knowledgeErrors.notFound',
  PRODUCT_KNOWLEDGE_INTERNAL_ERROR: 'knowledgeErrors.failed',
};
export const knowledgeTaskReasonKeys: Readonly<Record<string, string>> = {
  NO_GROUP_MAPPING: 'knowledgeErrors.groupMissing',
  INVALID_FILE: 'knowledgeErrors.parse',
  GENERATE_FAILED: 'knowledgeErrors.extraction',
  EMPTY_CONTENT: 'knowledgeErrors.emptyContent',
  SUBMIT_FAILED: 'knowledgeErrors.submit',
  PARSE_FAILED: 'knowledgeErrors.parse',
  EXTRACTION_FAILED: 'knowledgeErrors.extraction',
  SOURCE_EVIDENCE_INVALID: 'knowledgeErrors.evidence',
  QA_IMPORT_FAILED: 'knowledgeErrors.qaImport',
  QA_IMPORT_INVALID_PROGRESS: 'knowledgeErrors.progress',
  NO_VALID_ROWS: 'knowledgeErrors.noRows',
  CREATE_FAILED: 'knowledgeErrors.create',
  RETRY_FAILED: 'knowledgeErrors.retryFailed',
  MONTHLY_TASK_LIMIT_REACHED: 'knowledgeErrors.quota',
  INVALID_SPU_REQUEST: 'knowledgeErrors.invalid',
  MANUAL_KNOWLEDGE_DELETE_UNSUPPORTED: 'knowledgeErrors.manualDelete',
  ACTIVE_TASK_EXISTS: 'knowledgeErrors.active',
  MANUAL_KNOWLEDGE_PROTECTED: 'knowledgeErrors.manualProtected',
  SOURCE_UNCHANGED: 'knowledgeErrors.unchanged',
  NO_NEW_KNOWLEDGE: 'knowledgeErrors.noKnowledge',
  ROW_INVALID: 'knowledgeErrors.rowInvalid',
  IDENTIFIER_NOT_FOUND: 'knowledgeErrors.identifierMissing',
  SCOPE_RESOLUTION_FAILED: 'knowledgeErrors.scopeFailed',
};
const legacyCodes: Readonly<Record<string, string>> = {
  '404': 'NOT_FOUND',
  '1000': 'SYSTEM_RUNTIME_ERROR',
  '1001': 'TEMPLATE_NOT_FOUND',
  '1002': 'KNOWLEDGE_NOT_FOUND',
  '1003': 'ACTIVITY_NOT_FOUND',
  '2001': 'SPU_CLASS_NAME_DUPLICATED',
  '2002': 'PHYSICAL_PRODUCT_NAME_DUPLICATED',
  '3001': 'MARK_TAG_GET_TRADE_FAIL',
  '3002': 'MARK_TAG_GET_DEPARTMENT_FAIL',
  '3003': 'MARK_TAG_GET_REVIEW_FAIL',
  '3004': 'READ_EXCEL_FAIL',
  '3005': 'NOT_SUPPORT_DEFINITION_CODE',
  '3006': 'GROUP_NAME_DUPLICATED',
  '5001': 'AI_QUERY_REWRITE_FAIL',
  '5002': 'HISTORY_QUESTION_FINALIZE_INVALID_REQUEST',
  '5003': 'HISTORY_QUESTION_FINALIZE_JOB_NOT_FOUND',
  '5004': 'HISTORY_QUESTION_FINALIZE_RETRY_CONFLICT',
  '5101': 'CIH_HISTORY_QUESTION_INVALID_REQUEST',
  '5102': 'CIH_HISTORY_QUESTION_JOB_NOT_FOUND',
  '5103': 'CIH_HISTORY_QUESTION_BATCH_SEALED',
  '5104': 'CIH_HISTORY_QUESTION_BATCH_NOT_READY',
  '5105': 'CIH_HISTORY_QUESTION_BATCH_BUSY',
  '4100': 'SPU_DETAIL_INVALID_REQUEST',
  '4101': 'SPU_DETAIL_UNAUTHORIZED',
  '4104': 'SPU_DETAIL_NOT_FOUND',
  '4109': 'SPU_DETAIL_CONFLICT',
  '4110': 'SPU_DETAIL_MONTHLY_TASK_LIMIT_REACHED',
  '4413': 'SPU_DETAIL_DISABLED',
  '4200': 'DOCUMENT_KNOWLEDGE_INVALID_REQUEST',
  '4201': 'DOCUMENT_KNOWLEDGE_UNAUTHORIZED',
  '4204': 'DOCUMENT_KNOWLEDGE_NOT_FOUND',
  '4209': 'DOCUMENT_KNOWLEDGE_CONFLICT',
  '4210': 'DOCUMENT_KNOWLEDGE_IDEMPOTENCY_CONFLICT',
  '4211': 'DOCUMENT_KNOWLEDGE_MONTHLY_TASK_LIMIT_REACHED',
  '4300': 'PRODUCT_KNOWLEDGE_INVALID_REQUEST',
  '4309': 'PRODUCT_KNOWLEDGE_SCOPE_CONFLICT',
  '4400': 'SUPPLEMENTAL_KNOWLEDGE_INVALID_REQUEST',
  '4404': 'SUPPLEMENTAL_KNOWLEDGE_NOT_FOUND',
  '4502': 'PRODUCT_KNOWLEDGE_INTERNAL_ERROR',
};

function record(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : {};
}
function own(table: Readonly<Record<string, string>>, code: string): string | undefined {
  return Object.prototype.hasOwnProperty.call(table, code) ? table[code] : undefined;
}
function safeCode(value: unknown): string {
  const code =
    typeof value === 'string' ? value.trim() : typeof value === 'number' ? String(value) : '';
  return /^[A-Z][A-Z0-9_]{0,95}$|^\d{1,8}$/.test(code) ? code : '';
}
// HTTP envelopes use a service namespace; task reason codes keep their own bare format.
function safeHttpCode(value: unknown): string {
  const code = typeof value === 'string' ? value.trim() : '';
  return /^[A-Z][A-Z0-9_]{0,95}:[A-Z][A-Z0-9_]{0,95}$/.test(code) ? code : safeCode(value);
}

export function readKnowledgeError(error: unknown) {
  const source = record(error);
  const response = record(source.response);
  const data = record(source.data);
  const config = record(source.config ?? response.config);
  const meta = record(record(source.command).meta);
  const requestPath = config.url ?? meta.path;
  if (typeof requestPath === 'string' && !/(?:^|\/)oversea-knowledge(?:\/|$)/.test(requestPath))
    return { code: '', key: undefined };
  const body = record(response.data ?? data.data ?? source);
  const symbolic = safeHttpCode(body.errorCode);
  const hasSymbolic = body.errorCode != null && body.errorCode !== '';
  const lookupCode = symbolic.startsWith('OVERSEA_KNOWLEDGE:')
    ? symbolic.slice('OVERSEA_KNOWLEDGE:'.length)
    : symbolic;
  const numeric = safeCode(body.code);
  return {
    code: symbolic || numeric,
    key: hasSymbolic
      ? own(knowledgeApiErrorKeys, lookupCode)
      : own(knowledgeApiErrorKeys, own(legacyCodes, numeric) ?? ''),
  };
}
export function describeKnowledgeApiError(
  error: unknown,
  t: Translate = (key) => tolgee.t(key),
  fallback?: string,
): string {
  if (error instanceof KnowledgeTaskError)
    return (
      error.items
        .map((item) => describeKnowledgeTaskReason(item, t))
        .filter(Boolean)
        .join(' · ') || t('knowledgeErrors.failed')
    );
  const { key } = readKnowledgeError(error);
  if (key) return t(key);
  return fallback ?? t('knowledgeErrors.failed');
}
export interface KnowledgeTaskReason {
  status?: unknown;
  errorCode?: unknown;
  reasonCode?: unknown;
  errorReason?: unknown;
  errorMessage?: unknown;
}
export function describeKnowledgeTaskReason(
  task: KnowledgeTaskReason,
  t: Translate = (key) => tolgee.t(key),
): string | null {
  if (
    [
      'SUCCESS',
      'FINISHED',
      'CREATED',
      'READY',
      'PENDING',
      'RUNNING',
      'CANCELLED',
      'CANCELED',
    ].includes(String(task.status))
  )
    return null;
  const code = safeCode(task.reasonCode) || safeCode(task.errorCode) || safeCode(task.errorReason);
  if (
    !code &&
    !task.errorMessage &&
    !['FAILED', 'SKIPPED', 'PARTIAL_SUCCESS'].includes(String(task.status))
  )
    return null;
  return t(
    own(knowledgeTaskReasonKeys, code) ??
      (task.status === 'SKIPPED' ? 'knowledgeErrors.skipped' : 'knowledgeErrors.taskFailed'),
  );
}

export function isKnowledgeApiError(error: unknown): boolean {
  const source = record(error);
  const config = record(source.config ?? record(source.response).config);
  return /(?:^|\/)oversea-knowledge(?:\/|$)/.test(String(config.url ?? ''));
}

/** 本地携带结构化批量失败项，展示时才读取当前语言。 */
export class KnowledgeTaskError extends Error {
  constructor(readonly items: KnowledgeTaskReason[]) {
    super('Knowledge task operation failed');
  }
}
